import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const ImageGalleryModal = ({ isOpen, onClose, item }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  if (!isOpen || !item) return null;

  const handlePrevious = () => {
    setCurrentImageIndex((prev) => (prev === 0 ? item?.images?.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentImageIndex((prev) => (prev === item?.images?.length - 1 ? 0 : prev + 1));
  };

  const handleThumbnailClick = (index) => {
    setCurrentImageIndex(index);
  };

  return (
    <div className="fixed inset-0 bg-foreground/80 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="bg-background rounded-lg w-full max-w-4xl max-h-[90vh] overflow-hidden elevation-3 flex flex-col">
        <div className="flex items-center justify-between p-4 border-b border-border">
          <div>
            <h2 className="text-lg font-semibold text-foreground">{item?.name}</h2>
            <p className="text-sm text-muted-foreground font-mono">{item?.liin}</p>
          </div>
          <button
            onClick={onClose}
            className="p-2 rounded-md hover:bg-muted transition-smooth touch-target"
            aria-label="Close gallery"
          >
            <Icon name="X" size={24} />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto">
          <div className="relative bg-muted">
            <div className="w-full h-96 flex items-center justify-center overflow-hidden">
              <Image
                src={item?.images?.[currentImageIndex]?.url}
                alt={item?.images?.[currentImageIndex]?.alt}
                className="w-full h-full object-contain"
              />
            </div>

            {item?.images?.length > 1 && (
              <>
                <button
                  onClick={handlePrevious}
                  className="absolute left-4 top-1/2 -translate-y-1/2 w-12 h-12 bg-background/90 backdrop-blur-sm rounded-full border border-border hover:bg-background transition-smooth flex items-center justify-center touch-target"
                  aria-label="Previous image"
                >
                  <Icon name="ChevronLeft" size={24} />
                </button>

                <button
                  onClick={handleNext}
                  className="absolute right-4 top-1/2 -translate-y-1/2 w-12 h-12 bg-background/90 backdrop-blur-sm rounded-full border border-border hover:bg-background transition-smooth flex items-center justify-center touch-target"
                  aria-label="Next image"
                >
                  <Icon name="ChevronRight" size={24} />
                </button>

                <div className="absolute bottom-4 left-1/2 -translate-x-1/2 bg-background/90 backdrop-blur-sm px-3 py-1.5 rounded-full border border-border">
                  <span className="text-sm font-medium text-foreground">
                    {currentImageIndex + 1} / {item?.images?.length}
                  </span>
                </div>
              </>
            )}
          </div>

          <div className="p-4">
            <h3 className="text-sm font-semibold text-foreground mb-3">All Photos</h3>
            <div className="grid grid-cols-4 sm:grid-cols-6 md:grid-cols-8 gap-2">
              {item?.images?.map((image, index) => (
                <button
                  key={index}
                  onClick={() => handleThumbnailClick(index)}
                  className={`aspect-square rounded-lg overflow-hidden border-2 transition-smooth touch-target ${
                    currentImageIndex === index
                      ? 'border-primary' :'border-border hover:border-primary/50'
                  }`}
                >
                  <Image
                    src={image?.url}
                    alt={image?.alt}
                    className="w-full h-full object-cover"
                  />
                </button>
              ))}
            </div>
          </div>
        </div>

        <div className="p-4 border-t border-border">
          <Button variant="outline" onClick={onClose} fullWidth>
            Close Gallery
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ImageGalleryModal;